import {
  AccessControl,
  ALL_MODULES,
  AppContext,
  MoreTabsIcon,
  RefreshIcon,
  TabsCloseIcon,
  useActivityTracker,
  TAB_PAGES,
  getTranslatedText,
  SuperPop,
  EventEmitter,
  toast,
  useIsAuthorisedHook,
  GlobalAI,
  COMMON_CONSTANTS,
  NewTask,
  useProduct
} from '@nile/components';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';
import {
  Banner,
  Popover,
  TextStyle,
  Button,
  DisplayText,
  Link
} from '@superops/ui-design-system';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React, {
  createRef,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { ReactSortable } from 'react-sortablejs';
import styled from 'styled-components';
import {
  getTabContentData,
  getTabListContent,
  getTabTemplate
} from '@nile/mangifera/src/Pebbles/TabManager';
import { SVGIcon } from '@superops/super-icons';
import { debounce } from 'lodash';
import OnboardingProgressFloater from '../Pages/ProductOnboarding/OnboardingProgressFloater';
import GlobalChat from '@nile/components/src/Components/GlobalChat';
import { useGlobalChatHook } from '@nile/components/src/Components/GlobalChatHook';
import { isEmpty } from 'lodash';
import {
  SAVE_TICKET_CONVERSATION,
  TicketClient,
  UPDATE_TICKET
} from '@nile/graphql/src';
import ClosureModal from '@nile/mangifera/src/Components/Ticket/ClosureModal';
import { useMutation } from '@apollo/client';
import { getTabId } from '@nile/mangifera/src/Pebbles/TabManager';
import { getState } from '@nile/components/src/Managers/StateManager';
import AISummaryContainerFloaterPortal from '@nile/components/src/Components/AI/components/AISummaryContainerOld';
import { useChatFeatureEnabled } from '@nile/components/src/Pages/SystemTrayChatPage/utils';
import PaymentOverDueBanner from '../Pages/PaymentOverDueBanner';
import NylasBanner from '../Pages/NylasBanner';
import {
  useUserMSPCheckHook,
  useUserMSPCheckHookBasedOnProduct
} from '@nile/components/src/Utils/helpers';

const TabsWrapper = styled.div`
  height: 100%;
  width: calc(100% - 60px);
  .right-content {
    align-self: center;
    display: flex;
    flex: 1 1;
    justify-content: flex-end;
    .btn-holder {
      display: flex;
      align-items: center;
      .Superops-Button {
        border: none;
        background: #48ac3d;
        color: white;
        padding: 0 10px !important;
        height: 32px;
        min-height: 20px;
        margin-right: 8px;
      }
    }
    .trial-content {
      color: white;
      font-size: 12px;
      font-style: italic;
      display: flex;
      align-items: center;
      margin-right: 10px;
    }
  }
`;

const TabContentWrapper = styled.div`
  height: ${(props) =>
    props.setHeight ? `calc(100% - ${props.setHeight})` : 'calc(100% - 50px)'};
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  background: var(--sops-app-nav-bg-color);
  height: 50px;
`;

const TabListWrapper = styled.div`
  display: flex;
  overflow: auto;
  transform: translae3d(0, 0, 0);
  transition: all 200ms linear;
  scroll-behavior: smooth;
  -ms-overflow-style: none;
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
  max-width: calc(100vw - ${(props) => props.mxWidth || '150px'});
  .tabs-wrapper {
    display: flex;
    align-items: flex-end;
  }
`;

const ContainerWrapper = styled.div`
  height: 40px;
  min-width: 200px;
  max-width: 200px;
  color: ${(props) => (props.active ? '#000' : '#fff')};
  background: ${(props) =>
    props.active ? '#fff' : 'var(--sops-app-nav-bg-color)'};
  line-height: 19px;
  border-bottom: ${(props) =>
    props.active ? 'none' : '#1px solid rgba(151, 151, 151, 0.307474)'};
  border-radius: 10px 10px 0px 0px;
  display: flex !important;
  flex-grow: 1;
  align-items: center;
  font-size: 16px;
  padding-left: 10px;
  cursor: pointer;
  svg {
    filter: ${(props) =>
      !props?.darkThemeStatus
        ? props.active
          ? 'invert(0)'
          : 'invert(1)'
        : 'unset'};
  }
  .colorIcon {
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      filter: unset;
    }
  }
  .close {
    display: flex;
    visibility: ${(props) => (props.active ? 'visible' : 'hidden')};
    padding: 5px;
  }
  &:hover {
    background: ${(props) =>
      props.active ? '#fff' : 'var(--sops-app-nav-bg-color)'};
    .close {
      visibility: visible;
    }
    &:after {
      border-right: none;
      content: '';
    }
  }

  &:after {
    border-right: 1px solid var(--sops-white-to-white);
    content: '';
    height: 20px;
    opacity: 0.3;
  }
`;

const ListItemWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  align-items: center;
  color: ${({ active }) =>
    active ? '#000' : 'var(--sops-app-nav-text-color)'};
  .rotate {
    rotate: 360deg;
    transition: rotate 300ms linear;
  }
`;

const TabLinkWrapper = styled.div`
  max-width: 350px;
  min-width: 250px;
  .module-logo {
    width: 20px !important;
    height: 20px !important;
  }
  .tab-close-button {
    min-height: 25px;
    min-width: 20px;
  }
  .tab-close-icon {
    display: none;
  }
`;

const TabLink = styled.div`
  padding: 5px 20px;
  cursor: pointer;
  background: ${(props) => (props.active ? '#f5f5fc' : '')};
  &:hover {
    background: #f5f5fc;
    .tab-close-icon {
      display: block;
    }
  }
`;

const TabGroupHeader = styled.span`
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
`;

const TabsList = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 5px;
`;

const ArrowWrap = styled.div`
  height: 32px;
  width: 32px;
  justify-content: center;
  cursor: pointer;
`;

const MoreTabsWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

const RefreshTab = styled.div`
  svg {
    height: 15px;
    width: 15px;
  }
`;

const tablistWrapperRef = createRef();

let rotateTimer = null;

function Tabs(props) {
  const {
    tabs,
    onSelect,
    onChange,
    onTabAdd,
    closeTab,
    closeAllTabs,
    flags,
    refreshTab
  } = props;
  const options = {
    direction: 'horizontal',
    animation: 250,
    disabled: false
  };

  const intl = useIntl();

  const [list, setList] = useState(tabs);
  const [selected, setSelected] = useState(props.selected);
  const [tabListVisible, setTabListVisible] = useState(false);
  const [rotating, setRotating] = useState(false);
  const [popoverActive, setPopoverActive] = useState(false);
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  }, [popoverActive]);

  const appContext = useContext(AppContext);
  const tabContext = useContext(TabContext);
  const isChatAvailable = useChatFeatureEnabled();
  const {
    user,
    accountType,
    customerLicense,
    isSuperopsUser,
    isTrialUser,
    bannerVisibility
  } = appContext;
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const isITProduct = useProduct(COMMON_CONSTANTS.IT);
  const [technicianLicenseCount, setTechnicianLicenseCount] = useState(null);
  const [endpointLicenseCount, setEndpointLicenseCount] = useState(null);
  const [outboundEmailLicense, setOutboundEmailLicense] = useState(null);
  const [overageDetected, setOverageDetected] = useState(null);
  const isMsp = useUserMSPCheckHook();
  const isMSPBasedonProduct = useUserMSPCheckHookBasedOnProduct();
  const { getGlobalConversations } = useGlobalChatHook();

  const ticketConversationUx = flags?.ticketConversationUx;

  const globalConversationsData = getGlobalConversations();
  const globalConversationsRef = React.useRef([]);
  globalConversationsRef.current = globalConversationsData;
  const refItems = useRef({});

  // Use centralized banner visibility from AppContext
  const isNylasBannerVisible = bannerVisibility?.isNylasBannerVisible || false;
  const isPaymentBannerVisible =
    bannerVisibility?.isPaymentBannerVisible || false;
  const isLicenseBannerVisible =
    bannerVisibility?.isLicenseBannerVisible || false;
  const isMdmBannerVisible = bannerVisibility?.isMdmBannerVisible || false;

  // FEAT: Send and resolve ticket from global conversation.
  // 1. Subscribe to 'closureError' event
  // 2. If global conversation id is same as that of ticket id setGlobalClosureErrorFields
  // setGlobalClosureErrorFields and setGlobalClosureModalActive
  // 3. Else Emit another event to set closure error in other areas.
  // Adding global closure error fields
  const [globalClosureErrorFields, setGlobalClosureErrorFields] = useState('');
  const [globalClosureModalActive, setGlobalClosureModalActive] = useState(
    false
  );
  const [closureSaveLoading, setClosureSaveLoading] = useState(false);

  // 4.  this conversation data from global conversation is set using 'updateGlobalTicketConversationData' event emitter
  // 5. While closing ticket from global conversation we'll set the conversation data in this state
  // 6. If the mandatory fields are present along with conversation data is present, we'll update the ticket with conversation
  // 7. If the mandatory field is not present we'll set the conversation data to null after the api success in global conversation box

  const [
    globalTicketConversationData,
    setGlobalTicketConversationData
  ] = useState(null);

  const [globalTaskData, setGlobalTaskData] = useState(null);
  const [taskModalActive, setTaskModalActive] = useState(false);

  const getClosureFields = (errorFields) => {
    const ticketId = errorFields?.param?.ticketId;
    const isGlobalConversation = globalConversationsRef.current.find(
      (conversation) => {
        const globalConversationTicketId =
          conversation?.data?.ticket?.id ||
          conversation?.data?.ticket?.ticketId ||
          conversation?.id;
        return globalConversationTicketId === ticketId;
      }
    );

    // Fuction to set closure error fields
    // If global conversation id is same as that of ticket id we'll set globalClosureModalActive
    // and setGlobalClosureErrorFields
    // Else we'll emit ticketClosureError
    if (isGlobalConversation) {
      setGlobalClosureModalActive(true);
      setClosureSaveLoading(false);
      setGlobalClosureErrorFields({
        ticket: errorFields?.param.ticket,
        status: errorFields?.param?.status,
        fields: errorFields?.param?.fields
      });
    } else {
      EventEmitter.dispatch('ticketClosureError', errorFields);
    }
  };

  const resetTicketStoredTemplate = (ticketData) => {
    const ticketId = ticketData?.id;
    const requester = ticketData?.data?.requester;
    const client = ticketData?.data?.client;
    const subject = ticketData?.data?.subject;
    const sop = ticketData?.data?.sop;
    const ticket = {
      ticketId: ticketId,
      id: ticketId,
      requester: requester,
      client: client,
      sop: sop || null,
      subject: subject
    };
  };

  const onSendingGlobalConversation = (ticketId) => {
    const ticketData = globalConversationsRef.current.find((conversation) => {
      const globalConversationTicketId =
        conversation?.data?.ticket?.id ||
        conversation?.data?.ticket?.ticketId ||
        conversation?.id;
      return globalConversationTicketId === ticketId;
    });
    // State updates
    setGlobalClosureModalActive(false);
    setGlobalClosureErrorFields(null);
    setClosureSaveLoading(false);
    setGlobalTicketConversationData(null);

    // Event emitters
    EventEmitter.dispatch('refetchTicketAudit'); // To refetch ticket
    if (ticketConversationUx) {
      EventEmitter.dispatch('closeGlobalConversation', ticketData?.id); // To close conversation tab
      ticketData?.actions?.onClose();
      return;
    }

    if (!isEmpty(ticketData)) {
      resetTicketStoredTemplate(ticketData);
      // Event emitters
      EventEmitter.dispatch('globalConversationClosed', ticketData); // To check if action toolbar is disabled in chat feed container
      EventEmitter.dispatch('closeGlobalConversation', ticketData?.id); // To close conversation tab
    }
  };

  const saveTicketConversationWithTicketInput = (params) => {
    const conversationInput = params?.conversationInput;
    const ticketInput = params?.ticketInput;
    const ticketId = conversationInput?.ticketId;
    setClosureSaveLoading(true);
    const variables = {
      ...conversationInput,
      ticketInput: ticketInput
    };
    TicketClient.mutate({
      mutation: SAVE_TICKET_CONVERSATION,
      variables: variables
    })
      .then((res) => {
        if (res) {
          onSendingGlobalConversation(ticketId);
          toast('success', 'app.toast.ticket.update.success');
        }
      })
      .catch((err) => {
        closureSaveLoading(false);
      });
  };

  const [updateTicket] = useMutation(UPDATE_TICKET, {
    client: TicketClient
  });

  const updateGlobalTicketErrorFields = (ticket, variables) => {
    setClosureSaveLoading(true);
    const ticketId = ticket?.ticketId;

    updateTicket({
      variables: {
        id: ticketId,
        ...variables
      }
    })
      .then((res) => {
        if (res?.data?.updateTicket) {
          onSendingGlobalConversation(ticketId);
          toast('success', 'app.toast.ticket.update.success');
          if (flags?.agentChatFe && isChatAvailable) {
            EventEmitter.dispatch('globalTicketClosedSuccesfully', ticket);
          }
        } else {
          setClosureSaveLoading(false);
        }
      })
      .catch((err) => {
        setClosureSaveLoading(false);
      });
  };

  const updateGlobalTicket = (ticket, variables) => {
    if (isEmpty(globalTicketConversationData)) {
      updateGlobalTicketErrorFields(ticket, variables);
    } else {
      const conversationInput = globalTicketConversationData;
      const ticketInput = variables;
      const params = {
        conversationInput,
        ticketInput
      };
      saveTicketConversationWithTicketInput(params);
    }
  };

  const toggleTaskModalActive = (taskData) => {
    if (taskData) {
      const updatedState = !taskModalActive;
      setTaskModalActive(updatedState);

      if (updatedState) {
        setGlobalTaskData(taskData);
      } else {
        setGlobalTaskData(null);
      }
    } else {
      setGlobalTaskData(null);
      setTaskModalActive(false);
    }
  };

  useEffect(() => {
    EventEmitter.subscribe(
      'updateGlobalTicketConversationData',
      setGlobalTicketConversationData
    );
    EventEmitter.subscribe('closureError', getClosureFields);
    EventEmitter.subscribe('toggleGlobalTask', toggleTaskModalActive);

    setEndpointLicenseCount(
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isEndpointLicenseCountExceeded
    );

    setTechnicianLicenseCount(
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isTechnicianLicenseCountExceeded
    );

    setOutboundEmailLicense(
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isOutboundEmailRateLimitExceeded
    );

    setOverageDetected(
      customerLicense?.data?.getCustomerLicenseExceededDetails
        ?.isCommitedDeviceExceeded
    );

    return function cleanup() {
      EventEmitter.unsubscribe('updateGlobalTicketConversationData');
      EventEmitter.unsubscribe('closureError');
      EventEmitter.unsubscribe('toggleGlobalTask');
    };
  }, []);

  const setListItems = (items) => {
    if (flags?.deferTabState) {
      setList(items);
    }
    onChange && onChange(items);
  };

  useEffect(() => {
    setSelected(props.selected);
  }, [props.selected]);

  const scrollTabIntoView = useCallback(
    (selectedIndex) => {
      const selectedTab = list[selectedIndex];
      if (!selectedTab) return;

      const node = refItems.current[selectedTab.id];
      if (node && node.scrollIntoView) {
        node.scrollIntoView({
          behaviour: 'smooth',
          inline: 'nearest',
          block: 'end'
        });
      }
    },
    [list]
  );

  useEffect(() => {
    scrollTabIntoView(selected);
  }, [selected]);

  const switchTabFocus = (index, tab) => {
    if (flags?.deferTabState) {
      setSelected(index);
    }
    scrollTabIntoView(index);
    onSelect(index, tab);
  };

  const isTabRefreshable = (tab) => {
    switch (tab?.module) {
      case 'ONBOARD':
      case 'NEW':
      case 'CLIENT_CREATION':
      case ALL_MODULES.projectCreation:
      case 'ADD_ALERT_VIEW':
      case 'ADD_ASSET_GROUP_VIEW':
      case 'ADD_ASSET_VIEW':
      case 'ADD_PATCH_VIEW':
      case 'UPDATE_ASSET_GROUP_VIEW':
      case 'UPDATE_ASSET_VIEW':
      case 'UPDATE_ALERT_VIEW':
      case 'UPDATE_PATCH_VIEW':
      case 'CREATE_SCRIPT':
      case 'NEW_CONTRACT_TEMPLATE':
      case 'EDIT_CONTRACT_TEMPLATE':
      case 'REPORT_CREATION':
      case 'CHART_CREATION':
      case 'CREATE_TICKET_TEMPLATE':
      case 'UPDATE_TICKET_TEMPLATE':
      case 'CREATE_ALERT_EMAIL_TEMPLATE':
      case 'UPDATE_ALERT_EMAIL_TEMPLATE':
      case TAB_PAGES.mailbox:
      case TAB_PAGES.newInvoice:
      case TAB_PAGES.newQuote:
        return false;
      default:
        return true;
    }
  };
  function refreshBtn(e, tab) {
    setRotating(true);
    if (rotateTimer) {
      clearTimeout(rotateTimer);
    }
    rotateTimer = setTimeout(() => {
      setRotating(false);
    }, 300);
    refreshTab(tab);
    e.preventDefault();
    e.stopPropagation();
  }

  const getPageList = (listElements) => {
    return listElements.map((tab, index) => {
      return (
        <ContainerWrapper
          active={index === selected}
          darkThemeStatus={appContext?.darkTheme}
          key={`${tab.id}`}
          id={index}
          onClick={() => {
            switchTabFocus(index, tab);
          }}
          onTouchEnd={() => {
            switchTabFocus(index, tab);
          }}
          ref={(el) => {
            if (el) {
              refItems.current[tab.id] = el;
            } else {
              delete refItems.current[tab.id];
            }
          }}
        >
          <ListItemWrapper active={index === selected}>
            {getTabTemplate({
              module: tab?.module,
              data: tab?.data,
              allTabs: list,
              tab
            }) || ''}
            {index === selected && isTabRefreshable(tab) && (
              <RefreshTab
                className={`flex center ml4 ${rotating ? 'rotate' : ''}`}
                onClick={(e) => {
                  refreshBtn(e, tab);
                }}
                onTouchEnd={(e) => {
                  refreshBtn(e, tab);
                }}
              >
                <RefreshIcon />
              </RefreshTab>
            )}
            <div
              className="close mlauto"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                closeTab(tab);
              }}
              onTouchEnd={(e) => {
                e.preventDefault();
                e.stopPropagation();
                closeTab(tab);
              }}
            >
              <TabsCloseIcon height={10} width={10} />
            </div>
          </ListItemWrapper>
        </ContainerWrapper>
      );
    });
  };

  const checkTabVisibility = () => {
    return (
      tablistWrapperRef?.current?.scrollWidth >
      tablistWrapperRef?.current?.clientWidth
    );
  };

  useEffect(() => {
    setList(props.tabs);
  }, [props.tabs]);

  useEffect(() => {
    // To show/hide tabs list based on tab overflow state.
    setTabListVisible(checkTabVisibility());
  }, [list.length]);

  const handleTabAddition = () => {
    onTabAdd();
  };

  const getTabList = (listElements) => {
    return (
      <TabLinkWrapper className="fx fcol fhp pt-5 pb10">
        <div className="fx fx-sb pr-20 pl20 pt10 pb10">
          <TabGroupHeader>
            <FormattedMessage id="tabs.list.openTabs" />
          </TabGroupHeader>
          <span
            className="link-block"
            onClick={() => {
              closeAllTabs();
              togglePopoverActive();
            }}
          >
            <FormattedMessage id="tabs.list.closeAllTabs" />
          </span>
        </div>
        <div className="fx fcol f11 scroll">
          {listElements.map((tab, index) => {
            return (
              <TabLink
                active={index === selected}
                onClick={() => {
                  switchTabFocus(index, tab);
                  togglePopoverActive();
                }}
                key={tab.id}
              >
                <div className="fx actr">
                  <div className="f11 mr10 ellipsis">
                    {getTabListContent(
                      getTabContentData(tab?.data, tab?.module)
                    )}
                  </div>
                  <div
                    className="tab-close-button fx actr jctr"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      closeTab(tab);
                    }}
                  >
                    <span className="tab-close-icon">
                      <SVGIcon name="RejectedCircle" />
                    </span>
                  </div>
                </div>
              </TabLink>
            );
          })}
        </div>
      </TabLinkWrapper>
    );
  };

  const activator = (
    <ArrowWrap onClick={togglePopoverActive} className="flex actr">
      <MoreTabsIcon />
    </ArrowWrap>
  );

  const showUpgrade = accountType === 'MSP' && isTrialUser;
  const showEmailOutbound =
    user?.subscriptionStatus === 'ACTIVE' &&
    customerLicense?.data?.getCustomerLicenseExceededDetails
      ?.isOutboundEmailRateLimitEnabled;

  const horizontalScroll = (e) => {
    e.preventDefault();
    const tablistWrapper = tablistWrapperRef?.current;
    if (tablistWrapper && checkTabVisibility()) {
      const maxScrollLeft =
        tablistWrapper.scrollWidth - tablistWrapper.clientWidth;
      if (
        (tablistWrapper.scrollLeft > 0 && e.deltaY < 0) ||
        (tablistWrapper.scrollLeft < maxScrollLeft && e.deltaY > 0)
      )
        tablistWrapper.scrollLeft += e.deltaY * 2; // multiplying by 2 to add speed to scroll
    }
  };

  const handleBanner = () => {
    if (
      technicianLicenseCount &&
      endpointLicenseCount &&
      outboundEmailLicense
    ) {
      return 'customer.technician.endpoint.and.outboundEmail.license.count';
    }
    if (
      technicianLicenseCount &&
      endpointLicenseCount &&
      !outboundEmailLicense
    ) {
      return 'customer.technician.and.endpoint.license.count';
    }
    if (
      technicianLicenseCount &&
      !endpointLicenseCount &&
      outboundEmailLicense
    ) {
      return 'customer.technician.and.outboundEmail.license.count';
    }
    if (
      !technicianLicenseCount &&
      endpointLicenseCount &&
      outboundEmailLicense
    ) {
      return 'customer.endpoint.and.outboundEmail.license.count';
    }
    if (
      endpointLicenseCount &&
      !technicianLicenseCount &&
      !outboundEmailLicense
    ) {
      return 'customer.endpoint.license';
    }
    if (
      technicianLicenseCount &&
      !endpointLicenseCount &&
      !outboundEmailLicense
    ) {
      return 'customer.technician.license';
    }
    if (
      outboundEmailLicense &&
      !technicianLicenseCount &&
      !endpointLicenseCount
    ) {
      return 'customer.outboundEmail.license';
    }
    return 'customer.endpoint.not.exceeded';
  };

  const hideOnboardingFloater = props.tabs.find(
    (tab) => tab.module === 'PRODUCTONBOARD'
  );

  return (
    <TabsWrapper className="position-fixed" id="AppContentBoundary">
      {isNylasBannerVisible && (
        <div className="sops-warning">
          <NylasBanner />
        </div>
      )}

      {isPaymentBannerVisible && (
        <div className="sops-warning">
          <PaymentOverDueBanner
            invoiceCount={
              customerLicense?.data?.getCustomerLicenseExceededDetails
                ?.invoiceDueCount
            }
          />
        </div>
      )}

      {isMdmBannerVisible && (
        <div className="sops-warning">
          <Banner status="warning" alignContent="center">
            <div className="align-center">
              <FormattedMessage id="mdm.trial.expired.banner" />
              &nbsp;
              <Button
                plain
                onClick={() => {
                  tabContext.openTab({
                    module: 'ONBOARD',
                    url: isITProduct
                      ? '/onboard/mdm-client-setup'
                      : '/onboard/mdm-configurations'
                  });
                }}
              >
                <FormattedMessage id={'mdm.goto.configurations'} />
              </Button>
              &nbsp;
              <FormattedMessage id={'mdm.take.control.of.devices'} />
            </div>
          </Banner>
        </div>
      )}

      {!isPaymentBannerVisible &&
        isMSPBasedonProduct &&
        ((technicianLicenseCount && isMSPProduct) ||
          (endpointLicenseCount && isMSPProduct) ||
          outboundEmailLicense) && (
          <div className="sops-warning">
            <Banner status="warning" alignContent="center">
              <div className="align-center">
                <span>
                  <FormattedMessage id={handleBanner()} />
                </span>
                {outboundEmailLicense && (
                  <>
                    <Button
                      className="ml4"
                      plain
                      onClick={() => window.Intercom('show')}
                    >
                      <span className="pl3 capitalize">
                        <FormattedMessage id="admin.mspDetails.subdomain.support" />
                      </span>
                    </Button>
                    {isMSPProduct &&
                      outboundEmailLicense &&
                      (technicianLicenseCount || endpointLicenseCount) && (
                        <> or</>
                      )}
                  </>
                )}

                {isSuperopsUser &&
                  (technicianLicenseCount || endpointLicenseCount) && (
                    <AccessControl
                      roleToCheck="billingAndInvoice.view"
                      productToCheck={COMMON_CONSTANTS.MSP}
                      render={
                        <Button
                          className="ml4"
                          plain
                          onClick={() => {
                            tabContext.openTab({
                              module: 'ONBOARD',
                              url: '/onboard/billing',
                              state: {
                                openUpgradeLic: true
                              }
                            });
                            useActivityTracker({
                              event: 'Inproduct purchase',
                              data: { source: 'upgrade licence from hello bar' }
                            });
                          }}
                        >
                          <span className="pl3">
                            <FormattedMessage id="purchase.additional.licenses" />
                          </span>
                        </Button>
                      }
                    />
                  )}
              </div>
            </Banner>
          </div>
        )}

      <Wrapper>
        <TabListWrapper
          ref={tablistWrapperRef}
          onWheel={horizontalScroll}
          mxWidth={showUpgrade && '360px'}
        >
          <ReactSortable
            className="tabs-wrapper"
            options={options}
            list={list}
            setList={setListItems}
            direction="horizontal"
            animation={200}
            ghostClass="sortable-ghost"
            dragClass="sortable-drag"
          >
            {getPageList(list)}
          </ReactSortable>
        </TabListWrapper>

        <MoreTabsWrapper>
          <TabsList>
            <Popover
              preferredAlignment="right"
              activator={activator}
              active={popoverActive}
              onClose={togglePopoverActive}
              customClassName="popoverScrollElementPadding"
            >
              {getTabList(list)}
            </Popover>
          </TabsList>
          {showUpgrade && (
            <div
              className={`right-content w300 ${
                tabContext?.customerPaymentDetail ? 'hidden' : ''
              }`}
              title={
                tabContext?.customerPaymentDetail
                  ? getTranslatedText(intl, 'app.purchase.inprogress')
                  : ''
              }
            >
              <div className="ta-r text-white mr-10">
                <div>
                  <DisplayText size="medium">
                    {user?.subscriptionStatus === 'TRIAL'
                      ? `Trial expires in ${user?.trialExpiryDays} days`
                      : `Trial expired`}
                  </DisplayText>
                </div>
                {user?.subscriptionStatus !== 'TRIAL_EXPIRED' && (
                  <div className="flex">
                    <DisplayText size="medium">
                      {/* {`Monitoring ${customerLicense?.data?.getCustomerLicenseExceededDetails?.usedEndpointCount} of ${customerLicense?.data?.getCustomerLicenseExceededDetails?.licenseEndpointCount} assets`} */}
                      {`Asset & Email Limit : ${customerLicense?.data?.getCustomerLicenseExceededDetails?.licenseEndpointCount} `}
                    </DisplayText>
                    <div className="ml-5">
                      <SuperPop
                        position="top-start"
                        iconSize="sm"
                        content={
                          <div className="fw">
                            <div className="mb12">
                              {getTranslatedText(intl, 'account.trial.info')}
                            </div>
                            <div className="fx justify-end">
                              <div className="fx actr cursor-pointer g5">
                                <SVGIcon
                                  name="Headset"
                                  color="var(--sops-interactive)"
                                />
                                <Link removeUnderline>
                                  <span
                                    className="capitalize"
                                    onClick={() => window.Intercom('show')}
                                  >
                                    {getTranslatedText(
                                      intl,
                                      'admin.mspDetails.subdomain.support'
                                    )}
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </div>
                        }
                      />
                    </div>
                  </div>
                )}
              </div>
              {isSuperopsUser && (
                <div className="btn-holder">
                  {(isMSPProduct || flags?.itPricing) && (
                    <Button
                      onClick={() => {
                        tabContext.openTab({
                          module: 'ONBOARD',
                          url: '/onboard/billing',
                          state: {
                            openModal: true
                          }
                        });
                        useActivityTracker({
                          event: 'Inproduct purchase',
                          data: { source: 'A. Buy now button' }
                        });
                      }}
                      disabled={tabContext?.customerPaymentDetail}
                    >
                      <TextStyle>
                        <FormattedMessage id="app.pricing.buy.now" />
                      </TextStyle>
                    </Button>
                  )}
                </div>
              )}
            </div>
          )}
          {showEmailOutbound && (
            <div
              className={`right-content w300 ${
                tabContext?.customerPaymentDetail ? 'hidden' : ''
              }`}
            >
              <div className="ta-r text-white mr-10 fx actr">
                <DisplayText size="medium">{`Email Limit : 10`}</DisplayText>
              </div>

              <div className="btn-holder">
                <Button
                  onClick={() => {
                    useActivityTracker({
                      event: 'Email outbound verify click'
                    });
                    window.Intercom('show');
                  }}
                >
                  <TextStyle>
                    <FormattedMessage id="common.verify" />
                  </TextStyle>
                </Button>
              </div>
            </div>
          )}

          {flags?.itOverageBilling && overageDetected && (
            <div className={`fx mr4 actr w150p`}>
              <div className="ta-r text-white italic">
                <TextStyle>
                  <FormattedMessage id="itsm.pricing.overage.detected.label" />
                </TextStyle>
              </div>
              <div className="ml-5 mt2">
                <SuperPop
                  position="top-start"
                  iconSize="sm"
                  header={
                    <DisplayText weight="Bold" size="extraLarge">
                      {getTranslatedText(
                        intl,
                        'itsm.app.pricing.overage.supertip.header'
                      )}
                    </DisplayText>
                  }
                  content={
                    <div className="fw">
                      <div className="mb5">
                        {getTranslatedText(
                          intl,
                          'itsm.app.pricing.overage.supertip.info'
                        )}
                      </div>

                      <div className="pointer-events-all ">
                        <Link removeUnderline>
                          <span
                            className="capitalize"
                            onClick={() => {
                              tabContext.openTab({
                                module: 'ONBOARD',
                                url: '/onboard/billing',
                                state: {
                                  openUpgradeLic: true
                                }
                              });
                            }}
                          >
                            {getTranslatedText(
                              intl,
                              'app.pricing.view.billing'
                            )}
                          </span>
                        </Link>
                      </div>
                    </div>
                  }
                />
              </div>
            </div>
          )}

          <GlobalChat />
          {taskModalActive && (
            <NewTask
              {...globalTaskData}
              noRender
              state={taskModalActive}
              toggleSheetActive={toggleTaskModalActive}
              locked
            />
          )}

          <AccessControl roleToCheck="aiFeature.allow" render={<GlobalAI />} />

          {!isEmpty(globalClosureErrorFields) && (
            <>
              <ClosureModal
                modalActive={globalClosureModalActive}
                setModalActive={setGlobalClosureModalActive}
                errorsOnClosure={globalClosureErrorFields}
                setErrorsOnClosure={setGlobalClosureErrorFields}
                onSave={updateGlobalTicket}
                saveLoading={closureSaveLoading}
                onClose={() => {
                  setGlobalClosureErrorFields(null);
                  setGlobalClosureModalActive(false);
                  setClosureSaveLoading(false);
                  setGlobalTicketConversationData(null);
                }}
                showTicketData
                tabContext={tabContext}
                priotityAuthorised={useIsAuthorisedHook('customFields.view')}
              />
            </>
          )}
        </MoreTabsWrapper>
        {(isITProduct || (flags?.whatsnew && isMsp && isMSPProduct)) && (
          <div className="fx actr pl5 pr-15" id="sops-change-log">
            <SVGIcon name="SpaceRocket" color="var(--sops-white)" />
          </div>
        )}
      </Wrapper>
      <TabContentWrapper
        className="TabContentWrapper"
        setHeight={bannerVisibility?.isAnyBannerVisible ? '102px' : '50px'}
        key={tabs[selected]?.id}
      >
        {props.children}
        {!hideOnboardingFloater && <OnboardingProgressFloater />}
      </TabContentWrapper>
    </TabsWrapper>
  );
}

export default withRouter(withLDConsumer()(Tabs));
